/* Tastiness: BOZZA solo sul tema non pubblicato 190761107784. */
(function () {
  if (window.TasteAffettaturaAcquistoInstalled) return;
  window.TasteAffettaturaAcquistoInstalled = true;
  const states = new WeakMap();
  const root = () => window.Shopify?.routes?.root || '/';
  const language = (document.documentElement.lang || 'it').split('-')[0];
  const messages = {
    it:['Attendi l’aggiornamento della variante.','Aggiunta non riuscita. Riprova.','La scelta non è ancora salvata. Riprova prima del checkout.'],
    en:['Please wait for the variant update.','Could not add this item. Please retry.','Your choice is not saved yet. Please retry before checkout.'],
    fr:['Attendez la mise à jour de la variante.','Ajout impossible. Réessayez.','Le choix n’est pas encore enregistré. Réessayez avant le paiement.'],
    de:['Bitte warten Sie auf die Variantenaktualisierung.','Hinzufügen fehlgeschlagen. Bitte erneut versuchen.','Auswahl noch nicht gespeichert. Bitte vor dem Bezahlen erneut versuchen.'],
    es:['Espera a que se actualice la variante.','No se pudo añadir. Inténtalo de nuevo.','La elección aún no está guardada. Inténtalo de nuevo antes del pago.']
  };
  const t = messages[language] || messages.it;
  const service = () => window.TasteAffettatura;
  const eligibleInfo = info => info && service()?.isEligible(info.dataset.productId);
  const notice = (container, text) => {
    if (!container) return;
    let node = container.querySelector('[data-taste-acquisto-status]');
    if (!node) {node=document.createElement('p');node.dataset.tasteAcquistoStatus='';node.setAttribute('role','status');node.setAttribute('aria-live','polite');container.appendChild(node);}
    node.textContent = text;
  };
  const setup = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
      document.querySelectorAll('product-info').forEach(info => {
        if (info.dataset.section === data.sectionId) states.set(info,{pending:false,variant:data.variant});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true});
  else setup();
  document.addEventListener('change',event=>{
    const picker=event.target.closest('variant-selects');
    const info=picker?.closest('product-info');
    if (eligibleInfo(info)) states.set(info,{pending:true,variant:null});
  },true);
  document.addEventListener('click',async event=>{
    const button=event.target.closest('button');
    const handler=button?.getAttribute('onclick') || '';
    const matched=handler.match(/gestisciAcquistoCustom\s*\(\s*this\s*,\s*(\d+)\s*,\s*['"](add|buy)['"]\s*\)/);
    const info=button?.closest('product-info');
    // Compra ora keeps its original direct-checkout behavior.
    if (!matched || matched[2] === 'buy' || !eligibleInfo(info)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const container=button.closest('.custom-pdp-buttons-wrapper') || button.parentElement;
    const state=states.get(info);
    if (button.disabled || state?.pending || service().isBusy()) {notice(container,t[0]);return;}
    let variant=state?.variant;
    if (!state) {
      const data=info.querySelector('variant-selects [data-selected-variant]')?.textContent;
      if (data) {try {variant=JSON.parse(data);} catch(error) {notice(container,t[1]);return;}}
    }
    if (state && !variant) {notice(container,t[1]);return;}
    const id=Number(variant?.id || matched[1]);
    if (!Number.isSafeInteger(id) || id<=0 || variant?.available===false) {notice(container,t[1]);return;}
    // These existing buttons add one piece. Do not change that quantity contract.
    const original=button.textContent;
    button.disabled=true;
    notice(container,'');
    try {
      const response=await fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
      const added=await response.json();
      if (!response.ok) throw new Error(added.description || 'Aggiunta non riuscita');
      if (typeof window.forceOpenDrawer !== 'function') throw new Error('Carrello non disponibile');
      await window.forceOpenDrawer();
      // Only Add to cart is handled here. Buy now is left untouched.
    } catch(error) {
      notice(container,t[1]);
      console.error('[Affettatura acquisto]',error);
    } finally {
      button.disabled=false;
      button.textContent=original;
    }
  },true);
  document.addEventListener('click',async event=>{
    const link=event.target.closest('#CartDrawerContainer a[href*="/checkout"]');
    if (!link || !service()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const footer=document.getElementById('CartDrawerFooter');
    if (service().isBusy() || service().hasFailed()) {notice(footer,t[2]);return;}
    try {
      await service().prepareCheckout();
      window.location.assign(link.href);
    } catch(error) {
      notice(footer,t[2]);
      console.error('[Affettatura checkout]',error);
    }
  },true);
})();
